<template>
    <div v-if="$loadingRouteData"
         class="container -contract">
        <loader></loader>
    </div>
    <div v-if="!$loadingRouteData"
         class="container -contract">
        <ol class="breadcrumb">
            <li><a v-link="{name: 'home'}">Accueil</a></li>
            <li><a v-link="{name: 'clients'}">Membres</a></li>
            <li>
                <a v-link="{name: 'clients-detail', params: {id: client.id}}">
                    {{ client.name }}
                </a>
            </li>
            <li v-if="!contract.id">Ajouter un contrat</li>
            <li v-if="contract.id">Contrat #{{ contract.id }}</li>
        </ol>

        <div class="heading">
            <div class="f -gutter">
                <div class="expand">
                    <h1>
                        <span v-if="contract.id">
                            <strong>#{{ contract.id }}</strong> /
                        </span>
                        <editable-text :value.sync="contract.number"
                                       class="c-number"
                                       placeholder="Numéro"></editable-text>
                        &mdash;
                        <editable-choice v-if="companies"
                                         class="c-company"
                                         placeholder="Compagnie"
                                         :value.sync="contract.company"
                                         :options="companies"></editable-choice>
                        <editable-choice v-if="types"
                                         class="c-type"
                                         placeholder="Type de contrat"
                                         :options="types"
                                         :value.sync="contract.type"></editable-choice>
                    </h1>
                </div>
                <div>
                    <a v-link="{name: 'clients-detail', params: {id: client.id}}"
                       class="btn btn-link">
                        Annuler
                    </a>
                    <button class="btn btn-primary -save-contract"
                            v-on:click.prevent="save"
                            :class="valid ? '' : 'disabled'">
                        <loader :inline="true"
                                v-show="saving"></loader>
                        Enregistrer
                    </button>
                </div>
            </div>

            <div
                v-if="contract.allocation"
                class="f -a-end -gutter"
            >
                <div>
                    <h2>
                        <editable-choice
                            :value.sync="allocationId"
                            :options="compatibleAllocations"
                        ></editable-choice>
                    </h2>
                </div>
            </div>

            <div class="f -a-end -gutter">
                <div>
                    <h2>
                        <editable-number placeholder="Versement initial"
                                         class="c-wire-initial"
                                         :value.sync="contract.wire_initial">
                        </editable-number>
                        /
                        <editable-number placeholder="Versement mensuel"
                                         class="c-wire-monthly"
                                         :value.sync="contract.wire_monthly">
                        </editable-number>

                        <editable-choice :value.sync="contract.wire_period"
                                         :options="wirePeriods">
                        </editable-choice>
                    </h2>
                </div>

                <div class="expand align-right old-numbers"
                     v-if="contract.all_numbers.length || contract.promotional_code">
                    <div v-if="contract.all_numbers.length">
                        <span
                            v-if="contract.all_numbers.length >= 2">Anciens numéros&nbsp;:</span>
                        <span
                            v-if="contract.all_numbers.length < 2">Ancien numéro&nbsp;:</span>
                        <span v-for="number in contract.all_numbers">
                            <span v-if="$index !== 0">/</span>
                            {{ number }}
                        </span>
                    </div>
                    <div v-if="contract.promotional_code">
                        Code promotionnel : {{ contract.promotional_code }}
                    </div>
                </div>

            </div>
        </div>

        <ul class="nav nav-tabs" role="tablist">
            <li role="presentation"
                :class="{active: tab === 'recap'}">
                <a @click.prevent="switchTab('recap')"
                   href="#"
                   role="tab">
                    Récap
                </a>
            </li>
            <li role="presentation"
                v-if="contract.id"
                :class="{active: tab === 'operations'}">
                <a @click.prevent="switchTab('operations')"
                   href="#"
                   role="tab">
                    Opérations

                    <span class="badge" v-if="contract.pending_ops">
                        {{ contract.pending_ops}}
                    </span>
                </a>
            </li>
            <li role="presentation"
                v-if="contract.id"
                :class="{active: tab === 'documents'}">
                <a @click.prevent="switchTab('documents')"
                   href="#"
                   role="tab">
                    Documents
                </a>
            </li>
            <li role="presentation"
                v-if="contract.id"
                :class="{active: tab === 'exchanges'}">
                <a @click.prevent="switchTab('exchanges')"
                   href="#"
                   role="tab">
                    Échanges
                </a>
            </li>
        </ul>

        <operations-tab
            v-if="tab === 'operations'"
            :contract="contract"
            :contacts="client.contacts"
        ></operations-tab>

        <div v-if="tab === 'recap'">
            <template v-if="contract.has_historical_data">
                <h2>Données historiques</h2>

                <historical-data :contract="contract"></historical-data>
            </template>

            <h2>Notes</h2>

            <textarea placeholder="Notes..."
                      v-model="contract.notes"
                      v-autosize
                      class="form-control notes"></textarea>

            <h2>Dates</h2>

            <div class="row">
                <div class="col-sm-4">
                    <h4>Signature</h4>

                    <div>
                        <editable-date :value.sync="contract.date_sign"
                                       placeholder="Pas signé"
                                       :enable-reset="true"></editable-date>
                    </div>
                </div>
                <div class="col-sm-4">
                    <h4>Effet</h4>

                    <div>
                        <editable-date :value.sync="contract.date_start"
                                       placeholder="Inconnue"
                                       :enable-reset="true"></editable-date>
                    </div>
                </div>
                <div class="col-sm-4">
                    <h4>Transfert</h4>

                    <div>
                        <editable-date :value.sync="contract.date_transfer"
                                       placeholder="Inconnue"
                                       :enable-reset="true"></editable-date>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-4">
                    <h4>Résiliation</h4>

                    <div>
                        <editable-date :value.sync="contract.date_stop"
                                       placeholder="Contrat toujours actif"
                                       :enable-reset="true"></editable-date>
                    </div>
                </div>
                <div class="col-sm-4">
                    <h4>Rejet</h4>

                    <div>
                        <editable-date :value.sync="contract.date_reject"
                                       placeholder="Contrat non-rejetté"
                                       :enable-reset="true"></editable-date>
                    </div>
                </div>
            </div>

            <div v-if="contract.histories.length">
                <h2>Evolution des versements</h2>
                <div class="row -wires">
                    <div class="col-sm-12">
                        <table class="table table-hover">
                            <tr>
                                <th>Date</th>
                                <th>Versement ponctuel</th>
                                <th>Versement régulier</th>
                                <th>Fréquence</th>
                            </tr>
                            <tr>
                                <td>
                                    Initial
                                </td>
                                <td class="number-col">
                                    {{{wireWhenCreated.wire_initial | money}}}
                                </td>
                                <td class="number-col">
                                    {{{wireWhenCreated.wire_monthly | money }}}
                                </td>
                                <td>
                                    {{formatWirePeriod(wireWhenCreated.wire_period)}}
                                </td>
                            </tr>
                            <tr v-for="history in contract.histories">
                                <td>
                                    {{history.updated_at | date 'LLL'}}
                                </td>
                                <td class="number-col">
                                    {{{formatEvolutionInitial(history)}}}
                                </td>
                                <td class="number-col">
                                    {{{formatEvolutionMonthly(history)}}}
                                </td>
                                <td>
                                    {{{formatWirePeriod(history.new_wire_period)}}}
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>

            <h2>
                Process
                <a @click.prevent="addProcess"
                   class="btn btn-primary btn-sm">
                    <i class="glyphicon glyphicon-plus"
                       v-if="!loadAddProcess"></i>
                    <loader :inline="true"
                            v-if="loadAddProcess"></loader>
                    Lancer un process
                </a>
            </h2>

            <modal :show.sync="showAddProcess">
                <div class="modal-header"
                     slot="modal-header">
                    <h4>Ajouter un process</h4>
                </div>

                <div class="modal-body"
                     slot="modal-body">
                    <div v-for="process of availableProcesses">
                        <a @click.prevent="addThisProcess(process)"
                           class="btn btn-link">
                            {{ process.name }}
                        </a>
                    </div>
                </div>

                <div slot="modal-footer" class="modal-footer cta">
                    <a class="btn btn-default"
                       @click.prevent="showAddProcess = false">
                        Annuler
                    </a>
                </div>
            </modal>

            <div v-for="process in contract.processes">
                <h4>{{ process.name }}</h4>

                <div class="f -gutter -wrap">
                    <div class="btn-group">
                        <button type="button"
                                v-for="step in process.steps"
                                :class="{active: step.id === process.current_step}"
                                @click.prevent="process.current_step = step.id"
                                class="btn btn-default">
                            {{ $index + 1 }}. {{ step.name }}
                        </button>
                    </div>

                    <div>
                        <a class="btn btn-info"
                           @click.prevent="process.done = !process.done"
                           :class="{active: process.done}">
                            <span v-if="!process.done">
                                <i class="fa fa-square-o"></i>
                                En cours
                            </span>
                            <span v-if="process.done">
                                <i class="fa fa-check-square-o"></i>
                                Terminé
                            </span>
                        </a>

                        <a class="btn btn-success"
                           @click.prevent="sendMail(process)"
                           v-if="!process.done && contract.id">
                            <i class="fa fa-envelope-o"
                               v-if="!loadSendMail"></i>
                            <loader v-if="loadSendMail" :inline="true"></loader>
                            Envoyer un mail
                        </a>
                    </div>
                </div>
            </div>

            <modal :show.sync="showEmailModal">
                <div class="modal-header"
                     slot="modal-header">
                    <h4>Envoyer un email</h4>
                </div>

                <div class="modal-body"
                     slot="modal-body">
                    <h4>Destinataires</h4>

                    <div class="row">
                        <div class="col-sm-12">
                            <div v-for="recipient of mailPotentialRecipients">
                                <label for="rec-{{ $index }}">
                                    <input type="checkbox"
                                           checked
                                           id="rec-{{ $index }}"
                                           :value="recipient.id"
                                           v-model="mailRecipients"/>
                                    {{ recipient.name }} &lt;{{ recipient.email
                                    }}&gt;
                                </label>
                            </div>
                        </div>
                    </div>

                    <h4>Contenu</h4>

                    <div class="row">
                        <div class="col-sm-12">
                            <label>Sujet</label>
                            <input type="text"
                                   v-model="mailSubject"
                                   required
                                   class="form-control">
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12">
                            <label>Corps</label>
                            <textarea rows="10"
                                      class="form-control"
                                      v-model="mailBody"></textarea>
                        </div>
                    </div>

                    <h4>Pièces jointes</h4>

                    <div class="row">
                        <div class="col-sm-12">
                            <div v-for="doc of docsForEmail">
                                <label for="doc-{{ $index }}">
                                    <input type="checkbox"
                                           checked
                                           id="doc-{{ $index }}"
                                           :value="parseInt(doc.value, 10)"
                                           v-model="mailDocuments"/>
                                    {{ doc.label }}
                                </label>
                            </div>
                        </div>
                    </div>
                </div>

                <div slot="modal-footer" class="modal-footer cta">
                    <a class="btn btn-default"
                       @click.prevent="showEmailModal = false">
                        Annuler
                    </a>
                    <a class="btn btn-primary"
                       @click.prevent="doSendMail">
                        <loader v-if="loadSendMail" :inline="true"></loader>
                        Envoyer l'email
                    </a>
                </div>
            </modal>

            <h2>
                Intérêts Producteurs

                <button class="btn btn-primary btn-sm -add-producer"
                        v-if="availableProducersDb.length"
                        @click.prevent="promptAddProducer">
                    <i class="glyphicon glyphicon-plus"></i>

                    Ajouter un producteur
                </button>
            </h2>

            <table class="table table-striped"
                   v-if="contract.producer_interests.length">
                <tr>
                    <th></th>
                    <th>Acquisition</th>
                    <th>Encours</th>
                    <th>Reprise</th>
                </tr>

                <tr v-for="pi of contract.producer_interests">
                    <td>{{ producersMap[pi.producer].name }}</td>
                    <td>
                        <editable-number :value.sync="pi.pu"
                                         addon="%"
                                         v-bind:class="'pi-input-pu-' + pi.producer"
                                         placeholder="Acquisition %"></editable-number>
                    </td>
                    <td>
                        <editable-number :value.sync="pi.pp"
                                         addon="%"
                                         v-bind:class="'pi-input-pp-' + pi.producer"
                                         placeholder="Encours %"></editable-number>
                    </td>
                    <td>
                        <editable-number :value.sync="pi.reprise"
                                         addon="%"
                                         v-bind:class="'pi-input-reprise-' + pi.producer"
                                         placeholder="Reprise %"></editable-number>
                    </td>
                </tr>
            </table>

            <modal :show.sync="showProducerModal"
                   class="-add-producer">
                <div class="modal-header" slot="modal-header">
                    <h4>Ajouter un producteur</h4>
                </div>

                <div class="modal-body" slot="modal-body">
                    <div v-for="producer of availableProducersDb">
                        <a @click.prevent="addProducer(producer)"
                           class="btn btn-link -producer">
                            {{ producer.name }}
                        </a>
                    </div>
                </div>

                <div class="modal-footer" slot="modal-footer">
                    <button class="btn btn-link"
                            @click.prevent="showProducerModal = false">
                        Annuler
                    </button>
                </div>
            </modal>
        </div>

        <div v-if="tab === 'documents'">
            <documents-tab :contract="contract"></documents-tab>
        </div>

        <div v-if="tab === 'exchanges'">
            <exchanges-tab :contract="contract"></exchanges-tab>
        </div>
    </div>
</template>

<style scoped lang="less">
    @import '~src/style/variables';

    .-wires {
        margin-top: 20px;
    }
    .align-right {
        text-align: right;
    }

    .old-numbers {
        font-style: italic;
    }

    .heading {
        h1, h2 {
            margin: 0;
        }
    }

    .nav-tabs {
        margin: @grid-gutter-width 0;
    }

    .notes {
        font-family: monospace;
    }

    .badge {
        font-size: 80%;
    }
</style>

<script type="text/ecmascript-6">
    import Vue from 'vue';
    import router from '../router';
    import EditableText from '../components/editable/EditableText';
    import EditableChoice from '../components/editable/EditableChoice';
    import EditableNumber from '../components/editable/EditableNumber';
    import EditableDate from '../components/editable/EditableDate';
    import Loader from '../components/Loader';
    import {getAllCompanies, getAllCompaniesMap} from '../api/companies';
    import {emptyProducerInterest} from '../api/contract';
    import {fetch as fetchClient} from '../api/client';
    import {listAll as listAllProducers} from '../api/producers';
    import {
        emptyContract,
        create as createContract,
        fetch as fetchContract,
        update as updateContract,
        wirePeriods,
        sendMail
    } from '../api/contract';
    import {forContract, docsListToChoices} from '../api/document_types';
    import {listAll as listAllProcesses} from '../api/processes';
    import {asyncAction, tryOr404, d, mailTpl} from '../utils';
    import {manager as msgManager} from '../messages';
    import Modal from 'vue-strap/src/Modal';
    import ExchangesTab from '../components/clients/ExchangesTab.vue';
    import DocumentsTab from '../components/clients/DocumentsTab.vue';
    import OperationsTab from '../components/clients/OperationsTab.vue';
    import HistoricalData from '../components/contracts/HistoricalData.vue';

    export default {
        components: {
            Loader,
            Modal,
            ExchangesTab,
            DocumentsTab,
            EditableNumber,
            EditableChoice,
            EditableDate,
            EditableText,
            HistoricalData,
            OperationsTab
        },
        data() {
            let tab = 'recap';
            const routeTab = this.$route.query.tab;

            if (
                [
                    'recap',
                    'operations',
                    'documents',
                    'exchanges'
                ].some(x => x === routeTab)
            ) {
                tab = routeTab;
            }

            return {
                docName: '',
                tab,
                msgManager: msgManager,
                initialNumber: undefined,
                contract: {},
                companiesDb: undefined,
                producersDb: undefined,
                client: undefined,
                choices: {},
                docsForEmail: [],
                loadSendMail: false,
                mailSubject: '',
                mailBody: '',
                mailRecipients: [],
                mailPotentialRecipients: [],
                mailDocuments: [],
                showEmailModal: false,
                loadAddProcess: false,
                showAddProcess: false,
                availableProcesses: [],
                showProducerModal: false,
                wirePeriods: wirePeriods(),
                saving: false
            };
        },
        route: {
            data: tryOr404(async function (transition) {
                let contractPromise;

                if (transition.to.params.contractId) {
                    contractPromise = fetchContract(
                        transition.to.params.contractId, true
                    );
                } else {
                    contractPromise = emptyContract();
                }

                const [companiesDb, client, contract] = await Promise.all([
                    getAllCompanies(),
                    fetchClient(transition.to.params.id),
                    contractPromise
                ]);

                const producersDb = await listAllProducers();
                const docName = transition.to.params.docName;

                if (!contract.client) {
                    contract.client = client.id;
                } else if (contract.client !== client.id) {
                    throw new Error('fetched client id does not match contract client');
                }

                let tab = this.tab;
                if (docName) {
                    tab = 'documents';
                }

                return {
                    companiesDb,
                    client,
                    contract,
                    producersDb,
                    docName,
                    tab
                };
            })
        },
        props: {
            document: String
        },
        computed: {
            /**
             * Safe accessor to the histories
             */
            histories() {
                return (this.contract || {}).histories || [];
            },

            /**
             * Compute the amount as it was when contract was created
             **/
            wireWhenCreated() {
                if (this.histories.length === 0) {
                    return {
                        wire_initial: this.contract.wire_initial,
                        wire_monthly: this.contract.wire_monthly,
                        wire_period: this.contract.wire_period
                    };
                }

                const ordered = this.contract.histories.sort(function (a, b) {
                    if (a.updated_at > b.updated_at) {
                        return 1;
                    }
                    if (b.updated_at > a.updated_at) {
                        return -1;
                    }
                    return 0;
                });

                return {
                    wire_initial: ordered[0].old_wire_initial,
                    wire_monthly: ordered[0].old_wire_monthly,
                    wire_period: ordered[0].old_wire_period
                };
            },

            companies() {
                if (!this.companiesDb) {
                    return;
                }

                const out = [];

                for (const {name, slug} of this.companiesDb) {
                    out.push({value: slug, label: name});
                }

                return out;
            },

            companyMap() {
                if (!this.companiesDb) {
                    return;
                }

                const out = {};

                for (const company of this.companiesDb) {
                    out[company.slug] = company;
                }

                return out;
            },

            producersMap() {
                const out = {};

                this.producersDb.forEach((producer) => {
                    out[producer.id] = producer;
                });

                return out;
            },

            availableProducersDb() {
                const used = {};

                this.contract.producer_interests.forEach((pi) => {
                    used[pi.producer] = true;
                });

                return this.producersDb.filter((p) => !used[p.id]);
            },

            types() {
                if (!this.companyMap ||
                    !this.contract ||
                    !this.contract.company ||
                    !this.companyMap[this.contract.company]) {
                    return;
                }

                const company = this.companyMap[this.contract.company];
                const out = [];

                for (const {slug, name} of company.types) {
                    out.push({label: name, value: slug});
                }

                return out;
            },

            /**
             * Accessor to the allocation ID. As the list chooser expects a
             * string and the allocation ID is provided as an int, this
             * does the type conversion back and forth.
             */
            allocationId: {
                get() {
                    if (!this.contract || !this.contract.allocation) {
                        return;
                    }

                    return `${this.contract.allocation}`;
                },

                set(id) {
                    let idInt = parseInt(id, 10);

                    if (Number.isNaN(idInt)) {
                        idInt = null;
                    }

                    this.contract.allocation = idInt;
                }
            },

            /**
             * Converts the compatible allocations data into something that
             * the editable choice can handle.
             */
            compatibleAllocations() {
                if (
                    !this.contract.allocation ||
                    !this.contract.compatible_allocations
                ) {
                    return [];
                }

                return this.contract.compatible_allocations.map(
                    ({id, name}) => ({label: name, value: `${id}`})
                );
            },

            allNumbers() {
                const present = {};
                const out = [];

                function push(n) {
                    const l = n.toLowerCase();

                    if (present.hasOwnProperty(l)) {
                        return;
                    }

                    out.push(n);
                    present[l] = true;
                }

                if (this.contract && this.contract.number) {
                    push(this.contract.number);
                }

                if (this.contract && this.contract.all_numbers) {
                    this.contract.all_numbers.forEach(push);
                }

                return out;
            },

            valid() {
                const REQUIRED_FIELDS = [
                    'company',
                    'type',
                    'wire_initial',
                    'wire_monthly',
                    'wire_period'
                ];

                if (!this.contract) {
                    return false;
                }

                for (const k of REQUIRED_FIELDS) {
                    if (this.contract[k] === undefined) {
                        return false;
                    }
                }

                return true;
            }
        },
        watch: {
            'contract.type': function () {
                this.choices[this.contract.company] = this.contract.type;
            },
            'contract.company': function () {
                this.contract.type = this.choices[this.contract.company];
            },
            'contract.wire_monthly': function (v) {
                if (v < 1) {
                    this.contract.wire_period = 'none';
                } else if (this.contract.wire_period === 'none') {
                    this.contract.wire_period = 'monthly';
                }
            },
            'contract.wire_period': function (v) {
                if (v === 'none') {
                    this.contract.wire_monthly = 0;
                }
            }
        },
        methods: {
            /**
             * format the evolution of an initial wire
             **/
            formatEvolutionInitial(history) {
                const newValue = history[`new_wire_initial`];
                const oldValue = history[`old_wire_initial`];
                const diff = newValue - oldValue;
                const sign = diff > 0 ? '+' : '';
                let className = '';
                if (diff > 0) {
                    className = 'positive';
                }
                if (diff < 0) {
                    className = 'negative';
                }
                if (diff === 0) {
                    return `${Vue.filter('money')(newValue)}`;
                }
                return `${Vue.filter('money')(newValue)}
                    (<span class="${className}">` +
                    `${sign}${Vue.filter('money')(diff)}` +
                    `</span>)`;

            },
            /**
             * format the evolution of a wire (green id positive red otherwise)
             */
            formatEvolutionMonthly(history) {
                const newPeriod = history.new_wire_period;
                const newMonthValue = wirePeriods().filter(w => w['value'] ===
                    newPeriod)[0]['months'];
                const newValue = history[`new_wire_monthly`];
                const oldValue = history[`old_wire_monthly`];
                const diff = newValue - oldValue;
                const sign = diff > 0 ? '+' : '';
                let className = '';
                if (diff > 0) {
                    className = 'positive';
                }
                if (diff < 0) {
                    className = 'negative';
                }
                if (diff === 0) {
                    return `${Vue.filter('money')(newValue * newMonthValue)}`;
                }
                return `${Vue.filter('money')(newValue * newMonthValue)}
                    (<span class="${className}">` +
                    `${sign}${Vue.filter('money')(diff * newMonthValue)}` +
                    `</span>)`;

            },
            /**
             * Return the mapped name of a wire period (monthly => Mensuel)
             * @param field
             * @returns {String}
             */
            formatWirePeriod(field) {
                const filtered = wirePeriods().filter(w => w['value'] ===
                    field);
                if (filtered.length) {
                    return filtered[0].label;
                }
                return field;
            },
            switchTab(tab) {
                this.tab = tab;
            },
            save: asyncAction('saving', async function () {
                if (!this.contract) {
                    return;
                }

                const contract = this.contract;
                ['sign', 'start', 'stop'].forEach((x) => {
                    if (!contract[`date_${x}`]) {
                        contract[`date_${x}`] = null;
                    }
                });

                const oldAllNumbers = this.contract.all_numbers;

                try {
                    this.contract.all_numbers = this.allNumbers;

                    if (!this.contract.id) {
                        this.contract = await createContract(this.contract);
                        this.msgManager.push('Succès.', 'Le contrat a été créé.', 'success');
                        router.replace({
                            name: 'contracts-edit',
                            params: {
                                id: this.client.id,
                                contractId: this.contract.id
                            }
                        });
                    } else {
                        this.contract = await updateContract(this.contract);
                        this.msgManager.push('Succès', 'La mise à jour a été effectuée', 'success');
                    }
                } catch (e) {
                    this.msgManager.push('Erreur.', e.message, 'danger');
                    this.contract.all_numbers = oldAllNumbers;
                }
            }),
            addProcess: asyncAction('loadAddProcess', async function () {
                this.availableProcesses = await listAllProcesses();
                this.showAddProcess = true;
            }),
            addThisProcess(process) {
                process = Object.assign({}, process, {
                    current_step: process.steps[0].id,
                    done: false
                });
                delete process.id;
                this.contract.processes.push(process);
                this.showAddProcess = false;
            },
            sendMail: asyncAction('loadSendMail', async function (process) {
                const step = process.steps.filter((s) => s.id === process.current_step)[0];
                const companiesMap = await getAllCompaniesMap();
                const docs = await forContract(this.contract, step.document_types);

                this.docsForEmail = await docsListToChoices(
                    await forContract(this.contract, step.document_types, true)
                );
                this.mailDocuments = [];

                const mailCtx = {
                    envoi: this.contract.id,
                    documents: docs
                        .map((d) => `  - ${d.name}`)
                        .join('\n'),
                    destinataires: this.client.contacts
                        .map((c) => `${this.$options.filters.shortTitle(c.title)} ${c.last_name}`)
                        .join(', '),
                    compagnie: d(() => companiesMap[this.contract.company].name),
                    type: d(() => companiesMap[this.contract.company]
                        .types[this.contract.type]
                        .name)
                };

                this.mailSubject = mailTpl(mailCtx, step.email_subject);
                this.mailBody = mailTpl(mailCtx, step.email_body);

                this.mailPotentialRecipients = [];
                this.client.contacts.forEach((contact) => {
                    contact.info.forEach((info) => {
                        if (info.type === 'email') {
                            this.mailPotentialRecipients.push({
                                id: info.id,
                                email: info.value,
                                name: `${contact.first_name} ${contact.last_name}`
                            });
                        }
                    });
                });
                this.mailRecipients = this.mailPotentialRecipients.map((r) => r.id);

                this.showEmailModal = true;
            }),
            doSendMail: asyncAction('loadSendMail', async function () {
                await sendMail(this.contract, {
                    subject: this.mailSubject,
                    body: this.mailBody,
                    recipients: this.mailRecipients,
                    attachments: this.mailDocuments
                });
                this.showEmailModal = false;
            }),
            promptAddProducer() {
                this.showProducerModal = true;
            },
            addProducer(producer) {
                this.contract.producer_interests.push(emptyProducerInterest(producer.id));
                this.showProducerModal = false;
            }
        },
        ready: async function () {
            this.choices[this.contract.company] = this.contract.type;
            this.companiesDb = await getAllCompanies();
        }
    };
</script>



// WEBPACK FOOTER //
// Contract.vue?a34f791c